'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uploadAttachment = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _fileUploadGetters = require('conversations-internal-schema/file-upload/operators/fileUploadGetters');

var _trackInteraction = require('../../usage-tracking/actions/trackInteraction');

var _getSessionId = require('../../selectors/widgetDataSelectors/getSessionId');

var _fetchAttachmentUploadUrlClient = require('../clients/fetchAttachmentUploadUrlClient');

var _uploadAttachmentClient = require('../clients/uploadAttachmentClient');

var _createFormDataForAttachment = require('../util/createFormDataForAttachment');

var _attachmentUploadStart = require('../../file-uploads/actions/attachmentUploadStart');

var _attachmentUploadComplete = require('../../file-uploads/actions/attachmentUploadComplete');

var _attachmentErrors = require('../../file-uploads/constants/attachmentErrors');

var _handleAttachmentUploadProgress = require('./handleAttachmentUploadProgress');

var _attachmentError = require('../../file-uploads/actions/attachmentError');

var _associateFileAttachmentsWithThread = require('../../file-uploads/actions/associateFileAttachmentsWithThread');

var _fileUploadsConstants = require('../constants/fileUploadsConstants');

var _isPersistedThreadIdentifier = require('../../file-uploads/operators/isPersistedThreadIdentifier');

var uploadAttachment = exports.uploadAttachment = function uploadAttachment(_ref) {
  var attachment = _ref.attachment,
      threadId = _ref.threadId;
  return function (dispatch, getState) {
    var uploadStartTimestamp = Date.now();

    dispatch((0, _attachmentUploadStart.attachmentUploadStart)({ attachment: attachment, threadId: threadId }));
    var sessionId = (0, _getSessionId.getSessionId)(getState());
    var localId = (0, _fileUploadGetters.getLocalId)(attachment);
    var file = (0, _fileUploadGetters.getFile)(attachment);

    var formData = (0, _createFormDataForAttachment.createFormDataForAttachment)({ file: file });

    return (0, _fetchAttachmentUploadUrlClient.fetchAttachmentUploadUrlClient)({ sessionId: sessionId }).then(function (_ref2) {
      var uploadUrl = _ref2.uploadUrl;
      return (0, _uploadAttachmentClient.uploadAttachmentClient)({
        formData: formData,
        onProgress: function onProgress(_ref3) {
          var loaded = _ref3.loaded,
              total = _ref3.total;

          dispatch((0, _handleAttachmentUploadProgress.handleAttachmentUploadProgress)({
            localId: localId,
            threadId: threadId,
            loaded: loaded,
            total: total
          }));
        },
        uploadUrl: _fileUploadsConstants.FILE_MANAGER_API_PREFIX + '/' + uploadUrl
      });
    }).then(function (_ref4) {
      var _ref4$objects = _slicedToArray(_ref4.objects, 1),
          uploadedFile = _ref4$objects[0];

      var uploadCompleteTimestamp = Date.now();

      dispatch((0, _attachmentUploadComplete.attachmentUploadComplete)({
        localId: localId,
        threadId: threadId,
        fileId: uploadedFile.id
      }));

      if ((0, _isPersistedThreadIdentifier.isPersistedThreadIdentifier)(threadId)) {
        dispatch((0, _associateFileAttachmentsWithThread.associateFileAttachmentsWithThread)({
          fileIds: [uploadedFile.id],
          sessionId: sessionId,
          threadId: threadId
        }));
      }

      dispatch((0, _trackInteraction.trackInteraction)('attached-file', {
        action: 'attached file',
        'attachment-type': uploadedFile.extension,
        'attachment-size-bytes': file.size,
        'upload-time-ms': uploadCompleteTimestamp - uploadStartTimestamp
      }));
    }).catch(function () {
      dispatch((0, _attachmentError.attachmentError)(_attachmentErrors.UPLOAD_ERROR, threadId));

      dispatch((0, _trackInteraction.trackInteraction)('failed-to-attach-file', {
        action: 'failed to attach file',
        'failure-type': 'upload error'
      }));
    });
  };
};


//////////////////
// WEBPACK FOOTER
// ./js/file-uploads/actions/uploadAttachment.js
// module id = 558
// module chunks = 2 3